<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row" v-if="data && data.length > 0">
        <!-- Staff List Sidebar -->
        <div class="col-md-3 col-12 mb-3">
          <div class="staff-list-sidebar">
            <div class="staff-list-header">
              <strong>Staffs ({{ data.length }})</strong>
            </div>
            <div class="staff-list-container">
              <div
                v-for="staff in data"
                :key="'list-' + staff.id"
                class="staff-list-item"
                :class="{ 'staff-list-item-active': activeStaffKey === String(staff.id) }"
                @click="selectStaff(staff.id)"
              >
                <div class="staff-list-name">{{ staffName(staff) }}</div>
                <div class="staff-list-info">
                  <small class="text-muted">
                    {{ staff.staff_id || staff.system_staff_id }}
                    <span v-if="staff.staff_type">
                      &middot; {{ staff.staff_type.name }}
                    </span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tabs + Camera/Photo Area -->
        <div class="col-md-9 col-12">
          <div class="neo-tabs-fees">
            <a-tabs
              :tabPosition="settings['isMobileView'] ? 'top' : 'top'"
              :activeKey="activeStaffKey"
              @change="handleStaffChange"
            >
              <a-tab-pane
                v-for="staff in data"
                :tab="`${staffName(staff)} (${staff.staff_id || staff.system_staff_id})`"
                :key="String(staff.id)"
                :forceRender="true"
              >
                <staff-camera :data="staff" @updated="handlePhotoUpdate" />
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </div>
      <div v-else-if="!loading">
        <a-empty description="No staff members found" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StaffCamera from './partials/StaffCamera'

export default {
  name: 'StaffPhotoUpload',
  props: ['data', 'loading'],
  components: {
    StaffCamera,
  },
  data: function() {
    return {
      activeStaffKey: null,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    data: {
      handler(newData) {
        if (newData && newData.length > 0) {
          const currentIds = newData.map(s => String(s.id))
          if (!this.activeStaffKey || !currentIds.includes(this.activeStaffKey)) {
            this.activeStaffKey = String(newData[0].id)
          }
        } else {
          this.activeStaffKey = null
        }
      },
      immediate: true,
    },
  },
  methods: {
    handlePhotoUpdate() {
      this.$emit('updateTable')
    },
    handleStaffChange(key) {
      this.activeStaffKey = key
    },
    selectStaff(staffId) {
      this.activeStaffKey = String(staffId)
    },
    staffName(staff) {
      return [staff.first_name, staff.last_name].filter(val => val != null && val !== '').join(' ')
    },
  },
}
</script>

<style scoped>
.staff-list-sidebar {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fff;
}
.staff-list-header {
  padding: 10px 14px;
  border-bottom: 1px solid #e8e8e8;
  background: #fafafa;
}
.staff-list-container {
  max-height: 500px;
  overflow-y: auto;
}
.staff-list-item {
  padding: 8px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}
.staff-list-item:hover {
  background-color: #e6f7ff;
}
.staff-list-item-active {
  background-color: #e6f7ff;
  border-left: 3px solid #1890ff;
}
.staff-list-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}
.staff-list-info {
  margin-top: 2px;
}
</style>
